import { Model } from './typeHelper';
import * as types from '@comsbi/amplify/src/API';

export type StampCard = Model<types.GetStampCardQuery['getStampCard']>;

type DateTimeString = string;

export const TERM_OPTION = {
  UNLIMITED: 'unlimited', // 期限なし
  TERM: 'term', // 期間指定
  DAYS: 'days', // 初回すタンプ時から x日間
} as const;
export type TermType = typeof TERM_OPTION[keyof typeof TERM_OPTION];

/**
 * 日数指定 期限日の算出元
 */
export const TERM_DAYS_LIMIT_OPTION = {
  FIRST: 'first', // その周の最初のスタンプから
  LAST: 'last', // 直近のスタンプから
} as const;
export type TermDaysLimitOption = typeof TERM_DAYS_LIMIT_OPTION[keyof typeof TERM_DAYS_LIMIT_OPTION];

export type StampCardUiType =
  | 'CARD' // カード型
  | 'LIST'; // リスト型

export type StampCardQrType =
  | 'COMMON' // 共通QR
  | 'ITEM_UNIQUE'; // 項目別QR

export type StampCardRuleType =
  | 'ONCE' // 1回のみ
  | 'DAILY' // 一日1回のみ
  | 'UNLIMITED'; // 無制限

export type StampCardGoal = {
  // 識別キー
  key: string;
  // スタンプ数
  numOfStamps: number;
  // ポストバック
  triggerId?: string;
  // 周回指定
  round?: number;
  // ゴールかどうか
  isGoal?: boolean;
};

export type StampCardItem = {
  // 表示ラベル
  label: string;
  // 識別キー
  key: string;
  // CS-8747 スタンプ定義毎のポストバック
  triggerId?: string;

  // CS-8234 GPS対応
  latLng?: {
    lat: number;
    lng: number;
  };
};

export type StampCardSettings = {
  term: DateTimeString[] | null;
  // CS-8304 期限オプション
  termType?: TermType;
  // 有効期間 日数指定
  termDays?: number;
  // 有効期間 日数指定の算出元
  termDaysLimitOption?: TermDaysLimitOption;
  // 有効期間を過ぎたらリセットするかどうか
  resetOnExpiration?: boolean;
  // スタンプ可能時間
  stampEnabledTime?: {
    enabled?: boolean;
    start?: string[];
    end?: string[];
  };

  // 表示コンテンツ
  displayContents: {
    heroImageUrl?: string | null;
    description?: string | null;
  };
  // スタンプ数
  numOfStamps: number;
  // 予めのスタンプ押下フラグ
  preStamping: boolean;
  // ゴール
  goals: StampCardGoal[];
  // UIタイプ
  uiType: StampCardUiType;
  // QRタイプ
  qrType: StampCardQrType;
  // スタンプ項目
  items?: StampCardItem[];
  // スタンプ付与制約
  ruleType: StampCardRuleType;

  // CS-7533 カード繰り返し対応
  repeatRoundEnabled?: boolean;

  // CS-8234 GPS対応
  gps?: {
    // 緯度経度による条件付与 有効/無効
    enabled?: boolean;
    // スタンプ別の緯度経度設定 有効/無効
    stampLatLngEnabled?: boolean;
    // スタンプ共通の緯度経度
    latLng?: {
      lat: number;
      lng: number;
    };
  };
};

export type StampCardParsed = Omit<StampCard, 'settings'> & { settings: StampCardSettings };

export function extractStampCardSettings(model: StampCard) {
  return model.settings ? (JSON.parse(model.settings) as StampCardSettings) : null;
}
